import Vue from 'vue';
import VueRouter from 'vue-router';

import home from './home.js';
import login from './login.js';
import mymenu from './myMenu.js';
import indexFooderAboutPage from '@/views/common/aboutDetailPage/index.vue';
import pushRouder from './pushRoute.js';

Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单跳转当前页面报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    // commonMenu,
    home,
    login,
    mymenu,
    // { path: '/404', component: () => import('@/components/404.vue') },
    // { path: '*', redirect: '/404' },

	{
		path: '/indexFooderAboutPage',
		name: 'indexFooderAboutPage',
		component: indexFooderAboutPage,
		meta: {
			target: '_blank'
		}
	},

	pushRouder,

]
// console.log(routes);
export default new VueRouter({ routes });